// extracted by mini-css-extract-plugin
module.exports = {"journal":"behaviour_learning_log_style-module__journal___-9KCt"};